import { Button, Dialog, IconButton, Stack, TextField, Typography, DialogTitle, DialogContent, Box } from "@mui/material";
import { useEffect, useState } from "react";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveIcon from '@mui/icons-material/Save';
import ClearIcon from '@mui/icons-material/Clear';
import API from "../../../api";
import { startToast, updateToastError, updateToastSuccess } from "../../../utils/notification-loading";
import { btnStyle } from "../../../theme";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ImageFromBase64 from "../../../components/imageProfile";
import UploadImg from "../../../components/UploadImg";

const ProfileOptions = ({userData}) => {
  const [nome, setNome] = useState("");
  const [cognome, setCognome] = useState("");
  const [email, setEmail] = useState("");
  const [ragioneSociale, setRagioneSociale] = useState("");
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [authDlg, setAuthDlg] = useState(false);
  const [qrcode, setQrCode] = useState(null);
  const [secret, setSecret] = useState(null);
  const [imgProfile] = useState(sessionStorage.getItem('profileImage'));
  const [format] = useState(sessionStorage.getItem('imageType'));

  useEffect(() => {
    setNome(userData.nome ?? "");
    setCognome(userData.cognome ?? "");
    setEmail(userData.email ?? "");
    setRagioneSociale(userData.ragioneSociale ?? "");
  }, [userData]);

  const handleChangePassword = () => {
    startToast()
    API.reqForgotPassword({ email: email, type: sessionStorage.getItem("type") }).then((res) => {
      updateToastSuccess("Code sent successfully, check your email");
      window.location.href = res.data;
    }).catch((error) => {
      
      updateToastError("Error on password reset");
    })
  };

  return (
    <>
    <AuthenticatorDialog open={authDlg} setOpen={setAuthDlg} qrCode={qrcode} secret={secret} />
      <ConfirmDialog open={confirmDlg} setOpen={setConfirmDlg} setOpenDialog={setAuthDlg} setQrCode={setQrCode} setSecret={setSecret} />
      <Stack direction={"column"} spacing={2} flex={1}>
        <Stack direction={"row"} gap={4} alignItems={"center"}>
          <Box position={'relative'} display={'inline-flex'}>
            <ImageFromBase64 base64Data={imgProfile} format={format} style={{width: "100px", height: "100px"}}/>
            <UploadImg style={{position: "absolute", bottom: 0, right: 0}}/>
          </Box>
          <Typography fontSize={20}>{email}</Typography>
        </Stack>
        <CustomTextField variable={nome} setVariable={setNome} label={"Name"} tipo={"nome"} />
        <CustomTextField variable={cognome} setVariable={setCognome} label={"Surname"}  tipo={"cognome"} />
        <CustomTextField variable={ragioneSociale} setVariable={setRagioneSociale} label={"Company"}  tipo={"ragioneSociale"} />
        <Button sx={{...btnStyle, width: "fit-content" }} onClick={(e) => setConfirmDlg(true)}>CONFIGURE AUTHENTICATOR</Button>
        <Button sx={{...btnStyle, width: "fit-content"}} onClick={handleChangePassword}>CHANGE PASSWORD</Button>
      </Stack>
    </>
  )
};

export default ProfileOptions;

const CustomTextField = ({variable = "", setVariable, label, tipo}) => {
  const [disabled, setDisabled] = useState(true);
  const [newValue, setNewValue] = useState("");

  const handleChangeData = () => {
    startToast();
    API.changeUserData({tipo: tipo, value: newValue}).then((res) => {
      updateToastSuccess("Data changed successfully");
      setVariable(newValue);
      setDisabled(true);
    }).catch((error) => {
      
      setNewValue(variable);
      updateToastError("Error on data change");
    })
  }

  const slotProps = !disabled
    ? {
        input: {
          endAdornment: (
            <IconButton onClick={handleChangeData}>
              <SaveIcon />
            </IconButton>
          ),
        },
      }
    : undefined;

  useEffect(() => {
    setNewValue(variable);
  }, [variable]);

  return (
    <Stack direction={"row"} spacing={2}>
      <TextField
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
        label={label}
        disabled={disabled}
        slotProps={slotProps}
        fullWidth
      />
      {disabled ?
        <IconButton onClick={() => setDisabled(!disabled)}>
          <ModeEditIcon/>
        </IconButton>
      :
        <IconButton onClick={() => setDisabled(!disabled)}>
          <ClearIcon/>
        </IconButton>
      }
    </Stack>
  )
};

const ConfirmDialog = ({open, setOpen, setOpenDialog, setQrCode, setSecret}) => {

  const handleConfirm = () => {
    setOpenDialog(true);
    API.getAuthenticatorCode().then((response) => {
      setQrCode(response.data.qrCode);
      setSecret(response.data.secret);
    }).catch((error) => {
      
      updateToastError("Error on password reset");
    });
  }

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ textAlign: "center" }}>
        <WarningAmberIcon sx={{ fontSize: 60, color: "error.main" }} />
        <Typography sx={{ fontWeight: "bold", fontFamily: "Poppins", fontSize: "1.8rem", color: "error.main", mt: 1 }}>
          IMPORTANT ACTION REQUIRED
        </Typography>
        <Typography sx={{ fontWeight: 400, fontFamily: "Poppins", fontSize: "1rem", textAlign: "center", mt: 1 }}>
          From now on, this account will be configured with the authenticator.
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          gap: 3,
          mt: 2
        }}>
          <Button
            variant="outlined"
            color="inherit"
            sx={{ px: 3 }}
            onClick={() => setOpen(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="error"
            sx={{ px: 4, fontWeight: "bold" }}
            onClick={() => {
              handleConfirm();
              setOpen(false);
            }}
          >
            Confirm
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
};

const AuthenticatorDialog = ({open, setOpen, qrCode, secret}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        <Typography sx={{ fontWeight: "bold", fontFamily: "Poppins", fontSize: "1.5rem", textAlign: "center"}}>Authenticator Configuration</Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2
        }}>
          {qrCode && <img src={qrCode} alt="QR Code" />}
          {secret && <Typography>{secret}</Typography>}
        </Box>
      </DialogContent>
    </Dialog>
  )
};